import { useState, useEffect } from "react";
import "./StudyPage.css";
import { tsoCountries, tsos, tsosProps } from "../../components/TsoCell/tsos";
import { TsoCell } from "../../components/TsoCell/TsoCell";
import { TimestampsSelector } from "../../components/TimestampsSelector/TimestampsSelector";
import { Select, Loader } from "semantic-ui-react";
import "react-calendar/dist/Calendar.css";
import { CalendarInput } from "../../components/CalendarInput/CalendarInput";
import {
    ICalculation,
    validationProcessOptions,
    ltccTypesOptions,
    priorityOptions,
} from "../../models/calculation";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store/configureStore";
import { checkFileNameTimestamp } from "./validateZipFile";
import { formatDate } from "../../components/CalendarInput/formatDate";
import { HideToastMessage } from "../../actions/toastActions";
import { AppInfoMessage } from "../../components/AppInfoMessage/AppInfoMessage";
import { StudyTabs } from "./StudyTabs";
import { getVertices } from "../../store/verticesReducer";
import { SetSelectedTso, SetSelectedTsos } from "../../actions/selectedTsosActions";
import { StudyFileDropzones } from "./StudyFileDropzones";
import {
    LtccType,
    SetAvailableTimestampsOrScenarios,
    SetLtccMonthlyYearly,
    SetLtccType,
    SetValidationProcess,
    ValidationProcess,
} from "../../store/validationProcess";
import { getFileListFromZip, parseLtccXmlFromZip } from "../../components/StudyPageTabs/Configurations/zipLinesHelper";
import { create12Timestamps, create18Timestamps, create24Timestamps, create6Timestamps, createAvailableScenarios } from "../../components/TimestampsSelector/timestamps";
import { ResetZipFile } from "../../actions/filesActions";
import { SetTimestamps } from "../../actions/timestampsActions";
import { toast } from "../..";
import { SetAhc } from "../../store/verticesFilteringReducer";

export const StudyPage = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: AppState) => state.user);
    const { loading } = useSelector((state: AppState) => state.toast);
    const appStage = useSelector((state: AppState) => state.appStage);
    const { zipFile, xlsxFile } = useSelector((state: AppState) => state.files);
    const { selectedTso, selectedTsos } = useSelector((state: AppState) => state.selectedTsos);
    const [timestampDate, setTimestampDate] = useState(formatDate(new Date()));
    const [criticalTsos, setCriticalTsos] = useState<string[]>([]);
    const [priority, setPriority] = useState<number>(1);
    const validationProcess = useSelector((state: AppState) => state.validationProcess.process);
    const ltccType = useSelector((state: AppState) => state.validationProcess.ltccType);
    const ltccMonthlyYearly = useSelector(
        (state: AppState) => state.validationProcess.ltccMonthlyYearly
    );
    const vertices = useSelector((state: AppState) => state.vertices.vertices);
    const vertexSelection = useSelector((state: AppState) => state.vertices.vertexSelection);
    const ccValidation = useSelector((state: AppState) => state.ccValidation);
    const additionalOutages = useSelector(
        (state: AppState) => state.additionalOutage.additionalOutages
    );
    const cgmBranches = useSelector((state: AppState) => state.cgmBranches.cgmBranches);
    const cbBranches = useSelector((state: AppState) => state.cbBranches.cbBranches);
    const npShifts = useSelector((state: AppState) => state.npShifts.npShifts);
    const verticesLimits = useSelector((state: AppState) => state.verticesFiltering.verticesLimits);
    const selectedVertexFilteringType = useSelector((state: AppState) => state.verticesFiltering.vertexFilteringType);
    const raoReport = useSelector((state: AppState) => state.raoReport);
    const activeTimestamps = useSelector((state: AppState) => state.timestamps.timestamps);

    const handleSetSelectedTso = (tso: string) => {
        const oldTso = selectedTso;
        let newActiveTsos = selectedTsos.filter(x => x !== oldTso);
        if (!newActiveTsos.includes(tso)) newActiveTsos = newActiveTsos.concat(tso);
        dispatch(SetSelectedTso(tso));
        dispatch(SetSelectedTsos(newActiveTsos));
        dispatch(HideToastMessage());
    };

    const handleSetTsos = (tso: string) => {
        if (selectedTso !== tso)
            !selectedTsos.includes(tso)
                ? dispatch(SetSelectedTsos(selectedTsos.concat(tso)))
                : dispatch(SetSelectedTsos(selectedTsos.filter(x => x !== tso)));

        //set tso in tso select box
        if (selectedTso === "") {
            dispatch(SetSelectedTso(selectedTso));
        }
    };

    const getCalcJson = (calcType?: number): ICalculation => {
        const d = new Date();
        const dateString = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString();
        const calcDate = new Date(timestampDate).toISOString();
        const calcProps = {
            processType: "full",
            requestVerificationToken: "sakdfgsgaskfbklsdfg",
        };
        const calcTsos = selectedTsos.filter(x => x !== selectedTso);
        calcTsos.unshift(selectedTso);
        return {
            message: user.username!,
            started: dateString,
            calculationDate: calcDate,
            calcProps: JSON.stringify(calcProps),
            priority: priority,
            validationProcess: validationProcess,
            ltccType: ltccType,
            ltccMonthlyYearly: ltccMonthlyYearly,
            //vertices: getVertices(vertices, activeTimestamps),
            vertices: getVertices(
                vertices,
                activeTimestamps.map(d => d.key)
            ),
            tsos: calcTsos,
            necs: [],
            ccValidation: ccValidation,
            //timestamps: activeTimestamps,
            //timestamps: activeTimestamps.map(d => d.key),
            //don't send popupdescription
            activeTimestamps: activeTimestamps.map(({ popupdescription, ...rest }) => rest),
            vertexSelection: vertexSelection,
            criticalBranches: cgmBranches,
            npShifts: npShifts,
            verticesLimits: verticesLimits,
            selectedVertexFilteringType: selectedVertexFilteringType,
            f301Necs: cbBranches,
            additionalOutage: additionalOutages,
            raoReport: raoReport,
            calculationType: calcType ? calcType : 0,
            fileName: calcType && calcType === 2 ? (xlsxFile ? xlsxFile.name : "") : "",
        };
    };

    useEffect(() => {
        if (zipFile) {
            const timestamp = checkFileNameTimestamp(zipFile.name);
            if (timestamp.length > 0) setTimestampDate(formatDate(new Date(timestamp)));
        }
        //}, [zipFile]);
        if (validationProcess === ValidationProcess.Ltcc && zipFile) {
            parseLtccXmlFromZip(zipFile).then(res => {
                setTimestampDate(res.calculationDate);
                dispatch(SetLtccMonthlyYearly(res.ltccMonthlyYearly));
                if (res.availableScenarios.length < 1) {
                    toast(`Error while reading LT-001/LT-002 input files`, false, 30000);
                }
                const scenariosFromLtccFile = createAvailableScenarios(res.availableScenarios);
                dispatch(SetAvailableTimestampsOrScenarios(scenariosFromLtccFile));
                //Select loaded scenarios by default: https://gitlab.com/tscnet/perun4v/forum/-/issues/637
                dispatch(SetTimestamps(scenariosFromLtccFile));
            });
        } else if (validationProcess === ValidationProcess.Ltcc && !zipFile) {
            dispatch(SetAvailableTimestampsOrScenarios([]));
            dispatch(SetTimestamps([]));
        }
        else if (validationProcess === ValidationProcess.IntraDay && zipFile) {
            getFileListFromZip(zipFile).then(res => {
                if (res.containsFID3Cfiles) {
                    dispatch(SetAvailableTimestampsOrScenarios(create18Timestamps()));
                }
                else if (res.containsFID3files) {
                    dispatch(SetAvailableTimestampsOrScenarios(create12Timestamps()));
                }
                else if (res.containsFID3Efiles) {
                    dispatch(SetAvailableTimestampsOrScenarios(create6Timestamps()));
                }
                else {
                    dispatch(SetAvailableTimestampsOrScenarios(create24Timestamps()));
                }
            });
        }
        if (zipFile) {
            getFileListFromZip(zipFile).then(res => {
                if (validationProcess === ValidationProcess.DayAhead && res.containsAHCexternalConfiguration) {
                    dispatch(SetAhc(true))
                }
                else {
                    dispatch(SetAhc(false))
                }
            });
        }
        else {
            dispatch(SetAhc(false))
        }
    }, [zipFile, validationProcess, dispatch]);

    useEffect(() => {
        if (xlsxFile) {
            const timestamp = checkFileNameTimestamp(xlsxFile.name);
            if (timestamp.length > 0) setTimestampDate(formatDate(new Date(timestamp)));
        }
        if (validationProcess === ValidationProcess.IntraDay && xlsxFile) {
            getFileListFromZip(xlsxFile).then(res => {
                if (res.containsFID3Cfiles) {
                    dispatch(SetAvailableTimestampsOrScenarios(create18Timestamps()));
                }
                else if (res.containsFID3files) {
                    dispatch(SetAvailableTimestampsOrScenarios(create12Timestamps()));
                }
                else if (res.containsFID3Efiles) {
                    dispatch(SetAvailableTimestampsOrScenarios(create6Timestamps()));
                }
                else {
                    dispatch(SetAvailableTimestampsOrScenarios(create24Timestamps()));
                }
            });
        }
    }, [xlsxFile, validationProcess, dispatch]);

    useEffect(() => {
        const countries: string[] = [];
        cgmBranches.forEach(branch => {
            const country = branch.tsoOrigin;
            if (!countries.includes(country)) countries.push(country);
        });
        cbBranches.forEach(branch => {
            const country = branch.id.substr(0, 2);
            if (!countries.includes(country)) countries.push(country);
        });
        const newCriticalTsos: string[] = [];
        countries.forEach(country => {
            const tso = tsoCountries[country];
            if (!selectedTsos.includes(tso)) newCriticalTsos.push(tso);
        });
        setCriticalTsos(newCriticalTsos);
    }, [cgmBranches, cbBranches, selectedTsos]);

    //This is causing an issue after the calculation data is loaded and the user navigates back to the dashboard.
    /*
    useEffect(() => {
        if (user.role !== "Admin" && user.role !== "SuperAdmin") {
            dispatch(SetSelectedTso(user.tso!));
            dispatch(SetSelectedTsos([user.tso!]));
        }
    }, [dispatch, user.role, user.tso]);
    */

    useEffect(() => {
        return () => {
            dispatch(HideToastMessage());
        };
    }, [dispatch]);

    const environmentText = appStage.stage ? appStage.stage.toUpperCase() : "";

    return (
        <div id="study-page-container-div-a" className="study-page-container">
            <div id="study-page-title-div-a" className="study-page-title tsc-blue">
                <h1 id="study-page-title">
                    Local Capacity Calculation Validation
                    {environmentText && ` - ${environmentText}`}
                </h1>
                {loading && <Loader indeterminate active inline />}
            </div>
            <div id="study-page-content-a" className="study-page-content">
                <div
                    id="upper-selectors-container-studyPage-a"
                    className="upper-selectors-container"
                >
                    {validationProcess === ValidationProcess.Ltcc ? (
                        <div id="date-selector-studyPage-a" className="tso-selector">
                            <p id="p-select-business-studypage-a">Select LTCC type</p>
                            <Select
                                id="select-studypage-c2"
                                selectOnBlur={false}
                                value={ltccType}
                                options={ltccTypesOptions}
                                onChange={(e, data: any) => {
                                    dispatch(SetLtccType(data.value as LtccType));
                                }}
                            />
                        </div>
                    ) : (
                        <div id="date-selector-studyPage-a" className="date-selector">
                            <p id="select-timestamp-studypage-a">Select timestamp date</p>
                            <CalendarInput
                                primary="calendarInput-studyPage-a"
                                timestampDate={timestampDate}
                                handleTimestampDateChange={(e: any) =>
                                    setTimestampDate(formatDate(e))
                                }
                            />
                        </div>
                    )}
                    <div id="tso-selector-studypage-a" className="tso-selector">
                        <p id="selects-tso-studypage-a">Select TSO</p>
                        <Select
                            id="select-studypage-a"
                            placeholder="Select..."
                            search
                            disabled={user.role !== "Admin" && user.role !== "SuperAdmin"}
                            selectOnBlur={false}
                            value={selectedTso}
                            options={tsosProps}
                            onChange={(e, data: any) => handleSetSelectedTso(data.value)}
                        />
                    </div>
                    <div id="priority-selector-studypage-div-a" className="priority-selector">
                        <p id="p-select-priority-studypage-a">Select priority</p>
                        <Select
                            id="select-studypage-b"
                            selectOnBlur={false}
                            value={priority}
                            options={priorityOptions}
                            onChange={(e, data: any) => setPriority(data.value)}
                        />
                    </div>
                    <div
                        id="validation-type-selector-studypage-a"
                        className="validation-type-selector"
                    >
                        <p id="p-select-business-studypage-a">Select Business process</p>
                        <Select
                            id="select-studypage-c"
                            selectOnBlur={false}
                            value={validationProcess}
                            options={validationProcessOptions}
                            onChange={(e, data: any) => {
                                dispatch(SetValidationProcess(data.value as ValidationProcess));
                                if (
                                    ((data.value as ValidationProcess) === ValidationProcess.Ltcc &&
                                        validationProcess !== ValidationProcess.Ltcc) ||
                                    ((data.value as ValidationProcess) !== ValidationProcess.Ltcc &&
                                        validationProcess === ValidationProcess.Ltcc)
                                ) {
                                    //reset zip file and clear timestamps array when switching from ID/DA to LTCC
                                    dispatch(SetTimestamps([]));
                                    dispatch(ResetZipFile());
                                }
                            }}
                        />
                    </div>
                    <StudyFileDropzones />
                </div>
                <TimestampsSelector />
                <div id="grid-and-tabs-studypage-a" className="grid-and-tabs">
                    <div id="app-info-tsos-grid-studypage-a" className="app-info-tsos-grid">
                        <AppInfoMessage />
                        <div id="tsos-grid-studypage-a" className="tsos-grid">
                            {tsos.map(tso => (
                                <TsoCell
                                    key={tso}
                                    active={selectedTsos.includes(tso)}
                                    critical={criticalTsos.includes(tso)}
                                    name={tso}
                                    handleSetTsos={handleSetTsos}
                                />
                            ))}
                        </div>
                    </div>
                    <StudyTabs getCalcJson={getCalcJson} />
                </div>
            </div>
        </div>
    );
};
